module.exports = fox._r("images/preloader.gif", __webpack_public_path__ + "images/preloader.gif");


//////////////////
// WEBPACK FOOTER
// ./images/preloader.gif
// module id = 1092
// module chunks = 4